import { CountryEntity } from 'api/types/entity';
import { GridFields } from 'components';
import { useStableKeys } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { IconButton, Stack } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import {
  CountryRiskBadges,
  CountryRiskField,
} from 'modules/client/common/feature';

import { useFormContext, Field } from '../../../../forms/citizenshipForm';

export interface FormContentProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  onRemoveCitizenship?: (index: number) => void;
}

export const FormContent = ({
  countriesLoading,
  countries,
  onRemoveCitizenship,
}: FormContentProps) => {
  const { values, readOnly } = useFormContext();
  const { t } = useTranslation();

  const citizenshipKeys = useStableKeys(values.citizenships);

  return (
    <Stack spacing={32}>
      <GridFields>
        {values.citizenships.map((citizenship, index) => (
          <Field.Autocomplete
            key={citizenshipKeys[index]}
            label={t(
              index === 0
                ? 'client.client.citizenship.label'
                : 'client.client.citizenship.otherLabel'
            )}
            loading={countriesLoading}
            name={`citizenships.${index}` as 'citizenships'}
            optionLabelKey="name"
            options={countries}
            optionValueKey="id"
            placeholder={t('client.client.citizenship.placeholder')}
            renderOptionRightAdornment={(option) => <CountryRiskBadges
              country={option as CountryEntity}
              field={CountryRiskField.Citizenship}
            />}
            rightEndElement={
              !readOnly && index > 0 && onRemoveCitizenship ? (
                <IconButton
                  colorVariant="red"
                  icon={<Icon.Minus size={16} />}
                  mode="outlined"
                  sizeVariant="xs"
                  onClick={() => onRemoveCitizenship?.(index)}
                />
              ) : undefined
            }
            rightStartElement={
              <CountryRiskBadges
                country={citizenship}
                field={CountryRiskField.Citizenship}
              />
            }
            showRequiredMark={index === 0}
          />
        ))}
      </GridFields>
    </Stack>
  );
};
